import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useLanguage } from '../../hooks/useLanguage';
import { getTranslation } from '../../translations/presentation';
import { 
  Title, 
  Subtitle, 
  ContentContainer,
  PhoneButtonContainer,
  PhoneButton,
  ButtonText
} from '../../components/HeroSectionStyles';
import { FaMicrophone } from 'react-icons/fa';
import { loadVapiWidget, startVapiCall } from '../../services/vapiService';

const SlideWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  padding: 20px;
  overflow: hidden;
  position: relative;
`;

const SlideTitle = styled.h2`
  font-family: 'Orbitron', sans-serif;
  color: #64B6FF;
  margin-bottom: 30px;
  text-align: center;
  letter-spacing: 2px;
  font-size: 1.8rem;
  text-transform: uppercase;
  position: absolute;
  top: 30px;
  left: 0;
  right: 0;
  text-shadow: 0 0 10px rgba(100, 182, 255, 0.5);
  
  &::before {
    content: '//';
    color: rgba(100, 182, 255, 0.5);
    margin-right: 10px;
  }
`;

const ContentPreview = styled(ContentContainer)`
  max-width: 1200px;
  width: 90%;
  margin: 0 auto;
  padding: 60px;
  border: 1px solid rgba(100, 182, 255, 0.3);
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.2);
  box-shadow: 0 0 20px rgba(100, 182, 255, 0.1);
  backdrop-filter: blur(10px);
  position: relative;
  transform: scale(1.2) !important;
  will-change: transform;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: linear-gradient(90deg, transparent, rgba(100, 182, 255, 0.8), transparent);
  }
  
  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: linear-gradient(90deg, transparent, rgba(100, 182, 255, 0.8), transparent);
  }
`;

const PresentationSlide16 = () => {
  const { lang } = useLanguage();
  const t = getTranslation('slide16', lang);
  
  useEffect(() => {
    // Carrega o widget Vapi quando o componente é montado
    // Configurações específicas para versão em inglês
    const vapiConfig = lang === 'en' ? {
      language: 'en',
      voiceId: 'tnSpp4vdxKPjI9w0GnoV',
      firstMessage: 'hey'
    } : {
      language: 'pt',
      voiceId: '33B4UnXyTNbgLmdEDh5P',
      firstMessage: 'opa'
    };
    
    loadVapiWidget(vapiConfig);
  }, [lang]);

  const handleMicrophoneClick = () => {
    // Inicia a chamada quando o microfone é clicado
    startVapiCall();
  };

  return (
    <SlideWrapper>
      
      <ContentPreview>
        <Title>
          <div className="logo-container">
            <div className="logo-tech-circle"></div>
            <div className="logo-tech-data"></div>
            <img src="/favicon.png" alt="Logo Bianca" className="title-logo" />
          </div>
          <div className="title-text-container">
            <div className="tech-data-top">// AI.AGENT</div>
            <span className="title-text">BIANCA</span>
            <div className="tech-data-bottom">{/* data.transform(leads) */}</div>
          </div>
        </Title>
        
        <Subtitle>
          {t.subtitle}
        </Subtitle>
        
        <PhoneButtonContainer>
          <div>
            <PhoneButton onClick={handleMicrophoneClick}>
              <FaMicrophone />
            </PhoneButton>
            <ButtonText></ButtonText>
          </div>
        </PhoneButtonContainer>
      </ContentPreview>
    </SlideWrapper>
  );
};

export default PresentationSlide16;
